import { Component, Input } from '@angular/core';
import { DtoInvoiceVM } from '../../../Model/orders/DtoInvoiceVM';
import { OrdersService } from '../../../Services/orders.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../Shared/Services/auth.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html'
})
export class OrdersComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  @Input() IsMyOrders: boolean = false;
  @Input() IsSaved: boolean = false;
  AllProgressInvoices!: DtoInvoiceVM[];
  AlRecivedInvoices!: DtoInvoiceVM[];
  AlRejectedInvoices!: DtoInvoiceVM[];
  IsViewOrder: boolean = false;
  totalOrderCost?: number = 0;

  constructor(private api: OrdersService, private auth: AuthService, private toastrService: CustomToastrService,
    private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.admin, UserType.Agent, UserType.Workshop])) {
      this.spinner.show();
      if (!this.IsMyOrders && !this.IsSaved) {
        this.GetAllInvoicesFromAgentOrWorkShop(2);
      }
      else {
        this.GetAllInvoicesFromAgentOrWorkShop(1);
      }
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllInvoicesFromAgentOrWorkShop(isRecived?: any) {
    if (this.auth.isAuthenticated([UserType.admin, UserType.Agent, UserType.Workshop])) {
      this.api.GetAllInvoicesFromAgentOrWorkShop(isRecived)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (res: any) => {
              if (isRecived == 3) {
                this.AlRejectedInvoices = res.payload;
              }
              else if (isRecived == 2) {
                this.AlRecivedInvoices = res.payload;
              }
              else {
                this.AllProgressInvoices = res.payload;
              }
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  tabClick(tab: any) {
    this.spinner.show();
    if (!this.IsMyOrders && !this.IsSaved) {
      if (tab.index == 0) {
        this.GetAllInvoicesFromAgentOrWorkShop(1);
      }
      else if (tab.index == 1) {
        this.GetAllInvoicesFromAgentOrWorkShop(3);
      }
    }
    else {
      if (tab.index == 0) {
        this.GetAllInvoicesFromAgentOrWorkShop(1);
      }
      else if (tab.index == 1) {
        this.GetAllInvoicesFromAgentOrWorkShop(2);
      }
      else if (tab.index == 2) {
        this.GetAllInvoicesFromAgentOrWorkShop(3);
      }
    }
  }

  GetData(data: any) {
    this.IsViewOrder = data.IsViewOrder;
    this.totalOrderCost = data.totalOrderCost
  }

  CheckIsIsViewOrder(IsViewOrder?: any) {
    this.IsViewOrder = IsViewOrder;
  }
}
